module.exports = __webpack_public_path__ + "img/img_thermo.b170694e.png";